// import { ChevronRight } from "lucide-react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { NextArrow, PrevArrow } from "./PrevArrows";
const ResidencySlider = () => {
 const settings = {
  dots: false,

  infinite: true,            // 🔥 MUST be true for autoplay
  speed: 600,                // slide animation speed

  autoplay: true,            // ✅ enable auto scroll
  autoplaySpeed: 3000,       // ⏱️ 3 seconds per slide
  pauseOnHover: true,        // pause on hover
  pauseOnFocus: true,        // accessibility
  cssEase: "ease-in-out",    // smooth transition

  arrows: true,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,

  slidesToShow: 2,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1024, // Tablet
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768, // Mobile
      settings: {
        slidesToShow: 1,
        arrows: false,   // hide arrows on mobile
        dots: true,
      },
    },
  ],
};


  return (
   <section className="py-10 px-4 md:px-8 lg:px-16 bg-gradient-to-br">
      <div className="max-w-7xl mx-auto">
        
 <h2 className="text-4xl font-extrabold text-center mb-14">
         <span className="text-[#fd3e3d]">BENEFITS</span>
        </h2>
      <div className="max-w-6xl mx-auto">
              <Slider {...settings}>
               {[
  {
    title: "Benefit 1",
    description: "Intensive 3-Month Residency Program",
  },
  {
    title: "Benefit 2",
    description: "Access to the TACTOS Dashboard",
  },
  {
    title: "Benefit 3",
    description: "Access to top mentors, investors, and domain experts",
  },
  {
    title: "Benefit 4",
    description: "High-performance workspace & facilities",
  }
  
].map((data, i) => (
 
   <div key={i} className="px-2">
      {/* CARD */}
      <div
        className="
          group relative
          h-auto md:h-[140px]
          bg-white rounded-xl
          pl-8 pr-6 py-6
          border border-gray-100
          shadow-sm hover:shadow-lg
          transition-all duration-300
          flex flex-col space-y-4
        "
      >
        {/* Accent bar */}
        <div className="absolute left-0 top-0 h-full w-1  rounded-l-xl" />

        {/* Badge */}
        <span className="inline-block text-xs font-semibold text-[#fd3e3d] bg-red-50 px-3 py-1 rounded-full w-fit">
          {data.title}
        </span>

        {/* Content */}
        <p className="text-gray-900 text-lg font-semibold leading-snug">
          {data.description}
        </p>
      </div>
    </div>
))}

              </Slider>
            </div>

              <div className="max-w-6xl mx-auto mt-[28px]">
              <Slider {...settings}>
               {[
 
  {
    title: "Benefit 5",
    description: "Investor demo day with curated angels & micro-VCs",
  },
  {
    title: "Benefit 6",
    description: "Community of equally high-potential founders",
  },
  {
    title: "Benefit 7",
    description: "TACTOS Seal of Investment Readiness",
  },
  {
    title: "Benefit 8",
    description:
      "Confirmed funding for startups surviving the program from the TACTOS Seed Fund",
  },
].map((data, i) => (
  
   <div key={i} className="px-2">
      {/* CARD */}
      <div
        className="
          group relative
          h-auto md:h-[140px]
          bg-white rounded-xl
          pl-8 pr-6 py-6
          border border-gray-100
          shadow-sm hover:shadow-lg
          transition-all duration-300
          flex flex-col space-y-4
        "
      >
        {/* Accent bar */}
        <div className="absolute left-0 top-0 h-full w-1 rounded-l-xl" />

        {/* Badge */}
        <span className="inline-block text-xs font-semibold text-[#fd3e3d] bg-red-50 px-3 py-1 rounded-full w-fit">
          {data.title}
        </span>

        {/* Content */}
        <p className="text-gray-900 text-lg font-semibold leading-snug">
          {data.description}
        </p>
      </div>
    </div>

))}

              </Slider>
            </div>
      </div>
    </section>
  );
};

export default ResidencySlider;
